// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__Go3YP","appList":"NavBar_appList__jR0FO","userPanel":"NavBar_userPanel__cA-da"};